import { Formik } from "formik"
import { useLogin, usePermissions } from "hooks/auth"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Button, Form, FormFeedback, Input, Label, Alert } from "reactstrap"
import { Loading } from "components"

import schema from "./schema"

const LoginForm = () => {
  const [showErrorAlert, setShowErrorAlert] = useState(false)
  const login = useLogin()
  const me = usePermissions()

  useEffect(() => {
    const wrongArguments = login.error?.error_type === "WrongArguments"
    if (login.isError && wrongArguments) setShowErrorAlert(true)
  }, [login.isError])

  const handleOnSubmit = async (values) => {
    await login.mutateAsync(values)
    me.mutate()
  }

  const isLoading = login.isLoading || me.isLoading

  return (
    <Formik
      enableReinitialize
      initialValues={{
        email: "",
        password: "",
      }}
      validationSchema={schema}
      onSubmit={handleOnSubmit}
    >
      {({ values, handleChange, handleSubmit, handleBlur, touched, errors }) => (
        <Form className="form-horizontal" onSubmit={handleSubmit}>
          <Alert color="danger" isOpen={showErrorAlert} toggle={() => setShowErrorAlert(false)}>
            {login.error?.errors?.map((error) => error?.message)}
          </Alert>

          <div className="mb-3">
            <Label className="form-label">Email</Label>
            <Input
              name="email"
              className="form-control"
              type="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              invalid={!!(touched.email && errors.email)}
            />
            {touched.email && errors.email && <FormFeedback type="invalid">{errors.email}</FormFeedback>}
          </div>

          <div className="mb-3">
            <Label className="form-label">Contraseña</Label>
            <Input
              name="password"
              value={values.password}
              type="password"
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={!!(touched.password && errors.password)}
            />
            {touched.password && errors.password && <FormFeedback type="invalid">{errors.password}</FormFeedback>}
          </div>

          <div className="mt-3 d-grid">
            <Button color="dark" type="submit" disabled={isLoading}>
              <Loading isLoading={isLoading} /> Entrar
            </Button>
          </div>

          <div className="mt-4 text-center">
            <Link to="/forgot-password" className="text-muted">
              <i className="mdi mdi-lock me-1" />
              Olvide mi contraseña
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default LoginForm
